import { InitialSettingKinds } from "../InitialSettingKinds";
import { HisItemParameter } from "../../../domain/his/behavior/HisItemParameter";
import { IHisInformationApplicable, instanceOfIHisInformationApplicable } from "./IHisInformationApplicable";

export interface IInitialApplicable extends IHisInformationApplicable {
  isInitial: boolean;
  initialSettingKind: InitialSettingKinds;
  shouldSelectHospitalizationInitialValueHospitalizedOnly?: boolean;
  groupKey: string;
  hisItemParameter: HisItemParameter;
}

export function instanceOfIInitialApplicable(instance: any): instance is IInitialApplicable {
  if (!instance) { return false; }
  return (instance.isInitial !== undefined)
    && (instance.initialSettingKind !== undefined)
    && (instance.groupKey !== undefined)
    && (instance.hisItemParameter !== undefined)
    && instanceOfIHisInformationApplicable(instance);
}
